import { useEffect, useState } from "react";
import { ShimmerPostDetails } from "react-shimmer-effects";
import parse from "react-html-parser";

import { getSupportData } from "@/api/faq";
import Header from "@/components/common/header/DefaultHeader";
import MobileMenu from "@/components/common/header/MobileMenu";
import PageFooter from "@/components/common/PageFooter";
import PopupSignInUp from "@/components/common/PopupSignInUp";
import MetaComponent from "@/components/common/MetaComponent";
import { formatCmsTextToHtml } from "@/utils/textParser";
import "./index.css";

const metadata = {
  title: "Hubzu | Commercial Terms & Conditions",
  description:
    "Terms and conditions applicable to commercial real estate properties marketed and sold through the Hubzu platform.",
};

const CommercialTerms = () => {
  const [footerCmsData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [cmsData, setCmsData] = useState([]);

  useEffect(() => {
    const getCMSData = async () => {
      setLoading(true);
      setError(null);

      try {
        const data = await getSupportData("commercial-terms");
        if (data?.results) {
          setCmsData(data?.results);
        } else {
          throw new Error("No data found");
        }
      } catch (err) {
        setError(err?.message);
      } finally {
        setLoading(false);
      }
    };

    getCMSData();
  }, []);

  const renderContent = () => {
    if (loading) {
      return (
        <div className="loading-section">
          <ShimmerPostDetails card cta variant="EDITOR" />
        </div>
      );
    }

    if (error || !Array.isArray(cmsData) || cmsData.length === 0) {
      return (
        <div className="d-flex align-items-center justify-content-center vh-100">
          <div className="text-center">
            <div className="alert alert-danger" role="alert">
              <h2 className="alert-heading">Unable to Load Content</h2>
              <p>
                {error ||
                  "Sorry, something went wrong while fetching the data. Please try again later."}
              </p>
              <hr />
              <button
                className="btn btn-thm btn-primary"
                onClick={() => window.location.reload()}
              >
                Retry
              </button>
            </div>
          </div>
        </div>
      );
    }

    const content = cmsData[0] || {};

    return (
      <div className="termsContainer">
        <h1 className="termsheadingCls">
          {content?.title || "Terms and Conditions - Commercial Properties"}
        </h1>
        {/* Entire T&C body lives in a single CMS node */}
        <div className="termsGlossaryContainer">
          <div className="termsDescriptionFirst">
            {parse(formatCmsTextToHtml(content?.body))}
          </div>
        </div>
        {/* Published date shown at the bottom, after the T&C text */}
        {content?.effectiveDate ? (
          <p className="termsEffectiveDate">
            <strong>
              Published: <span>{content?.effectiveDate}</span>
            </strong>
          </p>
        ) : null}
      </div>
    );
  };

  return (
    <>
      <MetaComponent meta={metadata} />
      <div>
        <div className="d-flex flex-column min-vh-100">
          <Header />
          <MobileMenu />
          <PopupSignInUp />

          <div
            style={{
              flex: 1,
              marginTop: "calc(3.5rem + 1.75vw)",
              marginBottom: "calc(3.5rem + 1.75vw)",
            }}
            className="flex-grow-1"
          >
            {renderContent()}
          </div>

          <PageFooter footerCmsData={footerCmsData} showPartners={false} />
        </div>
      </div>
    </>
  );
};

export default CommercialTerms;
